import { toast } from 'react-toastify';

type CopyOptions = {
  successMessage?: string;
  errorMessage?: string;
};

export const copyToClipboard = async (
  textToCopy: string,
  options: CopyOptions = {},
): Promise<boolean> => {
  const {
    successMessage = 'Copied to clipboard',
    errorMessage = 'Failed to copy',
  } = options;

  if (!textToCopy) {
    toast.error(errorMessage);
    return false;
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(textToCopy);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
    toast.success(successMessage);
    return true;
  } catch {
    toast.error(errorMessage);
    return false;
  }
};

export default copyToClipboard;
